import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/subscription")({
  beforeLoad: () => {
    throw redirect({ to: "/settings", search: {"tab":"subscription"}, replace: true });
  },
});
